import { SortAsc, SortDesc } from 'assets/svg'
import T from 'core/i18n/t'
import { useState } from 'react'
import useFrequenciesFilter from '../../../context/hook'
import filterFrequency from '../../../lib/filterFrequency'
import { DVBCHistoryMapping, getModule } from '../../../lib/rfMapping'
import { getCellStatusColor, getRowStatusColor } from '../../../lib/thresholds'
import { FrequencyRow } from '../../../lib/types'
import { FrequencyLimitsType } from '../../redux/types'

export type DVBCRowType = {
  LF: string
  PWR: string
  BERPO: string
  LS: number
  TSID: string
}

type RfTuningDvbcTableProps = {
  dvbc: Array<DVBCRowType>
  frequencyLimits: FrequencyLimitsType
}

type ColumnOrder = 'ASC' |  'DESC'

type ToggleType = {
  ASC: ColumnOrder
  DESC: ColumnOrder
}

const toggleOrder: ToggleType = {
  ASC: 'DESC',
  DESC: 'ASC',
}

function sortList(current: FrequencyRow, prev: FrequencyRow, order: ColumnOrder) {
  if(order === 'ASC') {
    return parseInt(current.LF) - parseInt(prev.LF)
  }
  return parseInt(prev.LF) - parseInt(current.LF)
}

export default function DVBCTable({dvbc, frequencyLimits}: RfTuningDvbcTableProps) {
  const [order, setOrder] = useState<ColumnOrder>('ASC')

  const { filter } = useFrequenciesFilter()
  const mappedFrequencies = DVBCHistoryMapping(dvbc, frequencyLimits)
  const filteredFrequencies = filterFrequency(mappedFrequencies, filter)

  return (
    <>
      <div className="table-optimized" role="table">
        <div className="flex-table header has-status" role="rowgroup">
          <div className="flex-cell" role="columnheader">
            <T>rf_tuning.full_frequency_lf</T>
            <span
              className="clickable-icon"
              onClick={() => {
                setOrder(toggleOrder[order])
              }}
            >
              {order === 'ASC' ? <SortAsc className="icon icon-svg has-margin-left-sm" /> : <SortDesc className="icon icon-svg has-margin-left-sm" />}
            </span>
          </div>
          <div className="flex-cell" role="columnheader">
            <T>rf_tuning.full_frequency_pwr</T>
          </div>
          <div className="flex-cell" role="columnheader">
            <T>rf_tuning.full_frequency_berpo</T>
          </div>
          <div className="flex-cell" role="columnheader">
            <T>rf_tuning.full_frequency_ls</T>
          </div>
          <div className="flex-cell" role="columnheader">
            <T>rf_tuning.full_frequency_tsid</T>
          </div>
          <div className="flex-cell" role="columnheader">
            <T>rf_tuning.full_frequency_modulation</T>
          </div>
        </div>
        {filteredFrequencies.sort((current, prev) => sortList(current, prev, order)).map((row, index) => (
          <div className="flex-table row" role="rowgroup" key={index}>
            <div className="has-status" role="cell">
                <span className={`is-status ${getRowStatusColor(row.PWR.isHealthy, row.BERPO.isHealthy)}`}></span>
              </div>
            <div className="flex-cell" role="cell">
              {row.LF}
            </div>
            <div className={`flex-cell ${getCellStatusColor(row.PWR.isHealthy)}`} role="cell">
              {row.PWR.value}
            </div>
            <div className={`flex-cell ${getCellStatusColor(row.BERPO.isHealthy)}`} role="cell">
              {row.BERPO.value}
            </div>
            <div className="flex-cell" role="cell">
              {row.LS}
            </div>
            <div className="flex-cell" role="cell">
              {row.TSID}
            </div>
            <div className="flex-cell" role="cell">
            {getModule(row.LF.toString(), frequencyLimits)}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
